import type { ScreenModule } from "../../../app/screen-module";
import { NoticesPage } from "../pages";

export default {
	id: "system-admin.notices",
	path: "/system/notices",
	area: "system-admin",
	navGroup: "コンテンツ",
	label: "お知らせ / CMS",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: NoticesPage,
} satisfies ScreenModule;
